import store from '../store';
import APIService from './APIService';
import config from '../../config';
import { objectToQueryParams } from '../helpers/common';

/**  Connector Data Service Class extends API Service to use all the api Service method
 *  It provides All the method to get connector data
 *  Visit this link - @url https://dev-archive-explorer-service.xift.com/swagger-ui.html
 *  Vist this link for reports and restoration data for toolbox - @url https://dev-ms-o365-od-sp-restoration-service.xift.com/swagger-ui.html#
 */

//  main url for archive-explorer-service data service

const exploreUrl = config.baseUrlForArchiveExplorer;

const restorationUrl = config.baseUrlForRestorationService;
// This is a class based service to get the connector data
// It extends the APIService to use the methods of APIService
export default class VaultDataService extends APIService {
  // get the organisation connector data list

  static getConnectorData(
    { pageNumber, pageSize, type = 'ORG', projectId },
    bodyData = {},
    cancelToken
  ) {
    let orgId =
      type === 'ORG' ? store.state.currentlySelectedOrgId : store.state.orgId;

    let url;
    if (type === 'ORG') {
      url = `${exploreUrl}/v2/archives/organisation/${orgId}`;
    } else if (type === 'DISCOVERY') {
      url = `${exploreUrl}/v2/archives/discovery-project/${projectId}`;
    }
    const params = objectToQueryParams({ pageSize, pageNumber });
    url = `${url}?${params}`;
    if (type === 'DISCOVERY') {
      url = `${url}&org_id=${orgId}`;
    }
    return this.post(url, bodyData, cancelToken);
  }
  /**
   * Get the user connector data list
   * @args =>
   * Takes @pageNumber = which page number you want i.e 10,
   * Takes @pageSize = size of the page
   */

  static getUserConnectorData(
    { pageNumber, pageSize },
    bodyData = {},
    version,
    cancelToken
  ) {
    let userId = localStorage.getItem('userId');
    let orgId = store.state.orgId;
    let url = `${exploreUrl}`;
    const params = objectToQueryParams({
      pageSize,
      pageNumber,
      org_id: orgId
    });
    if (version === 'v2') {
      bodyData['accessibleBy'] = [userId, ...(bodyData?.accessibleBy || [])];
      url += `/v2/archives/organisation/${orgId}?${params}`;
    } else {
      url += `/archives/user/${userId}?${params}`;
    }

    return this.post(url, bodyData, undefined, cancelToken);
  }

  /**
   *
   * @param {Array<string>} archiveIds
   * @param {string} type
   */
  static getArchivesMetaData({ archiveIds, type = 'CURRENTORG' }) {
    //
    let orgId =
      type === 'CURRENTORG'
        ? store.state.orgId
        : store.state.currentlySelectedOrgId;
    let url = `${exploreUrl}/v2/archives/metaData`;
    return this.post(url, { archiveIds, currentOrg: orgId });
  }

  /**
   * To get connector file
   *
   * @param {string} archiveId <itemId>
   * @param {number} version
   * @param {string} format
   * @param {string} type (more like Enum)
   * @param {stirng} projectId
   *
   */
  static getConnectorArchive(
    {
      archiveId: itemId,
      version,
      format = 'PDF',
      type = 'ORG',
      projectId,
      responseType
    },
    cancelToken
  ) {
    let orgId =
      type === 'ORG' ? store.state.currentlySelectedOrgId : store.state.orgId;
    let url;
    if (type === 'ORG' || type === 'yourArchives') {
      url = `${exploreUrl}/archive/${itemId}?org_id=${orgId}`;
    } else if (type === 'DISCOVERY') {
      url = `${exploreUrl}/archive/discovery-project/${projectId}?format=PDF&archiveId=${itemId}`;
    }
    if (version && type !== 'DISCOVERY') {
      // it is hardcoded for discovery
      url = `${url}&format=${format}&version=${version}`;
    }
    return this.get(
      url,
      responseType ? responseType : 'blob',
      undefined,
      cancelToken
    );
  }

  /**
   *
   * @param {string} archiveId
   * @param {string} sourceType
   * @param {number} pageNumber
   * @param {string} type
   */
  static getConnectorArchiveVersions({
    archiveId,
    sourceType,
    pageNumber,
    pageSize,
    type
  }) {
    let orgId =
      type === 'yourArchives'
        ? store.state.orgId
        : store.state.currentlySelectedOrgId;
    const params = objectToQueryParams({
      org_id: orgId,
      source_type: sourceType,
      pageNumber,
      pageSize
    });
    let url = `${exploreUrl}/archive/${archiveId}/versions?${params}`;
    return this.get(url);
  }

  /**
   * Get restoration reports
   * For restoration url -> find it in env
   * @param {*} archiveId
   * @param {*} type
   */
  static getConnectorArchiveReports({ archiveId, type, version }) {
    let orgId =
      type === 'yourArchives'
        ? store.state.orgId
        : store.state.currentlySelectedOrgId;

    let url = `${restorationUrl}/toolbox/report`;
    if (version === 'v2') {
      url += '/v2';
    }
    return this.get(`${url}/${orgId}?archiveId=${archiveId}`);
  }

  /**
   * Restore Archive File
   * @param {*} type
   * @param {*} restoreIds
   */

  static restoreArchiveFile({ archives, type, action, exportTo }) {
    let orgId =
      type === 'yourArchives'
        ? store.state.orgId
        : store.state.currentlySelectedOrgId;
    const tenantId = store.state.currentOrgData?.tenantId;
    const { userId, primaryEmail } = store.state.userInformation;
    const timeZone = store.state.timezone?.source;

    const restoreBody = {
      archives,
      orgId,
      tenantId,
      userId,
      email: primaryEmail,
      timeZone,
      action,
      exportTo
    };
    let url = `${restorationUrl}/toolbox/restorer/restore`;
    return this.put(url, restoreBody);
  }

  /**
   *
   * @param {Array} archives
   * @param {string} type
   */
  static donwloadMultipleArchive(
    { archives, type },
    connectorType,
    cancelToken
  ) {
    const timeZone = store.state.timezone?.source;

    const bodyData = {
      archives,
      timeZone
    };
    let url = `${exploreUrl}/archives`;
    if (connectorType === 'TEAMS') {
      url += '/teams';
    }
    let orgId =
      type === 'yourArchives'
        ? store.state.orgId
        : store.state.currentlySelectedOrgId;
    url += `?org_id=${orgId}`;

    return this.post(url, bodyData, 'blob', cancelToken);
  }

  /**
   *
   * @param {string} orgId
   * @param {object} bodyData
   */
  static getConnectorArchiveCount({ orgId, bodyData }) {
    let url = `${exploreUrl}/${orgId}/discovery_project/archive/count`;
    return this.post(url, bodyData);
  }

  static getVaultVolume() {
    const currentOrgId = store.state.currentlySelectedOrgId;
    let url = `${exploreUrl}/vault/volume/${currentOrgId}`;
    return this.get(url);
  }

  /**
   * To get thread messages by @archiveId
   *
   * @param {number} pageNumber
   * @param {string} archiveId
   */
  static getThreadMessages({ pageNumber, archiveId }) {
    const currentOrgId = store.state.currentlySelectedOrgId;
    const url = `${exploreUrl}/ms-teams/organisations/${currentOrgId}/archives/${archiveId}/messages?pageSize=10&pageNumber=${pageNumber}`;
    return this.get(url);
  }

  /**
   * To get all list of all threads by @threadId
   *
   * @param {number} pageNumber
   * @param {string} threadId
   * @param {string} projectId
   */
  static getAllThreads({ pageNumber, messageGroupId, projectId = '' }) {
    const currentOrgId = store.state.currentlySelectedOrgId;
    const projectUrl = config.baseUrlForDiscoveryProject;
    let url;
    // Here we are handling url based on screens "Achive Search" & "Discovery Project --> Saved Items"
    // Used for "Discovery Project --> Saved Items"
    if (projectId) {
      url = `${projectUrl}/discovery/project/${projectId}/archives/${messageGroupId}?pageSize=2000&pageNumber=${pageNumber}`;
    } else {
      url = `${exploreUrl}/ms-teams/organisations/${currentOrgId}/messageGroups/${messageGroupId}/archives?pageSize=2000&pageNumber=${pageNumber}`;
    }
    return this.get(url);
  }

  /**
   * To get replies/versions on a message
   *
   * @param {number} pageNumber
   * @param {string} archiveId
   * @param {string} messageId
   * @param {string} messageType, it specifies what to get i.e. 'replies' OR 'versions'
   */
  static getChildMessages({ archiveId, messageId, messageType }) {
    const currentOrgId = store.state.currentlySelectedOrgId;
    const url = `${exploreUrl}/ms-teams/organisations/${currentOrgId}/archives/${archiveId}/messages/${messageId}/${messageType}`;
    return this.get(url);
  }
}
